const identity = x => x; // a -> a

export { identity };
